<template>
  <div>
    <ModalAjustaTempoAcesso ref="modalAjustaTempoAcesso" :usuarioEdicao="usuarioTempoAcesso" @usuarioSalvo="listarUsuarios" />
    <ModalCadastroUsuario ref="modalCadastroUsuario" @usuarioSalvo="listarUsuarios" :usuario-edicao="usuarioEdicao"
                          :faculdades="faculdades" :planos="planos" />
    <ModalExclusaoUsuarios ref="modalExcluirListaUsuarios" @usuariosExcluidos="listarUsuarios" />
    <ModalImportacaoUsuarios ref="modalImportarListaUsuarios" @importacaoFinalizada="importacaoFinalizada" />
    <ModalTrocaEmail :estudanteId="idUsuarioTrocaEmail" />
    <ModalMigracaoProgressoUsuarios ref="modalMigrarProgressoUsuarios" @importacaoFinalizada="importacaoFinalizada" />

    <div class="row align-items-center">
      <div class="col-12 col-md-4 text-center text-md-left mb-3">
        <form v-on:submit.prevent="listarUsuarios">
          <div class="form-inline justify-content-center justify-content-md-start">
            <div class="form-group mb-2">
              <label for="inputBusca" class="sr-only">Busca</label>
              <input type="text" class="form-control" id="inputBusca" @keypress="selecionarUsuario" v-model="buscaUsuario"
                     placeholder="Buscar usuário">
            </div>
            <button type="submit" class="btn btn-primary btn-busca mb-2 ml-2">
              <i class="fas fa-search" />
            </button>
            <small class="ml-3"><a href="javascript:void(0)" @click="limparFiltro" v-if="filtroBusca">Limpar filtro</a></small>
          </div>
        </form>
      </div>
      <div class="col-12 col-md-8 text-center text-md-right mb-3">
        <a href="javascript:void(0)" class="btn btn-primary ml-2" v-if="usuariosSelecionados.length === 0"
           @click="modalCadastrarUsuario"
        >
          <i class="fas fa-plus" /> Cadastrar usuário
        </a>

        <a href="javascript:void(0)" class="btn btn-secondary ml-2" v-if="usuariosSelecionados.length"
           @click="confirmRemoverUsuarioPorLote"
        >
          <i class="fas fa-trash-alt" /> Excluir usuários selecionados
        </a>

        <a href="javascript:void(0)" class="btn btn-secondary ml-2" v-if="usuariosSelecionados.length === 0"
           @click="modalMigrarProgressoUsuarios"
        >
          <i class="far fa-file-excel" aria-hidden="true" /> Migrar progresso
        </a>

        <a href="javascript:void(0)" class="btn btn-secondary ml-2" v-if="usuariosSelecionados.length === 0"
           @click="modalImportarListaUsuarios"
        >
          <i class="far fa-file-excel" aria-hidden="true" /> Importar lista
        </a>

        <a href="javascript:void(0)" class="btn btn-secondary ml-2" v-if="usuariosSelecionados.length === 0"
           @click="modalExcluirListaUsuarios"
        >
          <i class="fas fa-trash-alt" /> Excluir lista
        </a>
      </div>
    </div>

    <p class="text-right mt-3" v-if="quantidade"><strong>{{ quantidade }}</strong> itens</p>
    <div class="table-responsive tabela-usuarios mt-3" v-if="usuarios.length">
      <table class="table" ref="resultadoTabelaUsuarios">
        <thead>
        <tr>
          <th><input type="checkbox" v-model="selectAll" value="true"/></th>
          <th />
          <th>Usuário</th>
          <th>Nome</th>
          <th>Cpf</th>
          <th>Perfil</th>
          <th>Player 2</th>
          <th>Data de Cadastro</th>
          <th>Ações</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="usuario in usuarios" :key="usuario.id">
          <td><input type="checkbox" @click="alteraSelecionado(usuario)" v-model="usuariosSelecionados" :value="usuario" /></td>
          <td><img :src="usuario.avatar" /></td>
          <td>{{ usuario.email }}</td>
          <td>{{ usuario.name }}</td>
          <td><input type="text" v-mask="['###.###.###-##']" :value="usuario.cpf" class="input_cpf"></td>
          <td>{{ usuario.perfil }}</td>
          <td>
            <b-form-checkbox @change="alternarPlayerAlternativo($event, usuario)" v-model="usuario.playerAlternativo" switch />
          </td>
          <td>{{ usuario.dataCriacao }}</td>
          <td>
            <div class="d-flex align-items-center">
              <a href="javascript:void(0)" @click="confirmGerarAcesso(usuario)"
                 v-b-tooltip.hover title="Gerar link de acesso"
              >
                <i class="fas fa-user-secret" />
              </a>

              <a href="javascript:void(0)" @click="obterIdUsuarioTrocaEmail(usuario.id)"
                 v-b-modal.modal-trocar-email v-b-tooltip.hover title="Trocar e-mail do aluno"
              >
                <i class="fas fa-at" />
              </a>

              <a href="javascript:void(0)" @click="modalAjustaTempoAcesso(usuario)"
                 v-b-tooltip.hover title="Ajustar tempo de acesso"
              >
                <i class="far fa-calendar-alt" />
              </a>

              <a href="javascript:void(0)" @click="modalEditarUsuario(usuario.id)"
                 v-b-tooltip.hover title="Editar"
              >
                <i class="fas fa-edit" />
              </a>

              <a href="javascript:void(0)" @click="confirmRemoverUsuario(usuario)"
                 v-b-tooltip.hover title="Excluir"
              >
                <i class="fas fa-trash-alt" />
              </a>

              <a href="javascript:void(0)" @click="definirSenha( usuario )" v-b-modal.modal-definir-senha v-b-tooltip.hover title="Definir senha do aluno"><i class="fas fa-key"></i></a>
              <a href="javascript:void(0)" @click="resetarProgresso(usuario)"
                 v-b-tooltip.hover title="Resetar progresso"
              >
                <i class="fas fa-sync" />
              </a>
              <a href="javascript:void(0)" v-if="!usuario.email_verified_at" @click="validarEmail( usuario.id )" v-b-modal.modal-validar-email v-b-tooltip.hover title="Validar email do aluno"><i class="fas fa-user-check"></i></a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>

      <transition name="fade">
        <div class="btn-top text-center d-block" v-if="scrolled">
          <a href="javascript:void(0)" @click="scrollToTop"><i class="fas fa-chevron-circle-up" /> ir para o topo</a>
        </div>
      </transition>

    </div>

    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <div slot="no-results">Sua busca não retornou resultados</div>
      <div slot="no-more"></div>
    </infinite-loading>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import 'jspdf-autotable'
import Swal from 'sweetalert2'

import FaculdadeAPI from '@/api/faculdade-api'
import PlanoAPI from '@/api/plano-api'
import UsuarioAPI from '@/api/usuario-api'
import { TipoPerfilUtil } from '@/core/types/tipo-perfil'
import DateUtils from '@/core/util/date-utils'
import ResponseUtils from '@/core/util/response-utils'
import ModalAjustaTempoAcesso from '@/modules/Usuario/components/ModalAjustaTempoAcesso'
import ModalCadastroUsuario from './ModalCadastroUsuario'
import ModalExclusaoUsuarios from './ModalExclusaoUsuarios'
import ModalImportacaoUsuarios from './ModalImportacaoUsuarios'
import ModalTrocaEmail from '@/modules/Usuario/components/ModalTrocaEmail'
import ModalMigracaoProgressoUsuarios from './ModalMigracaoProgressoUsuarios'

const customSwal = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary mr-3',
    cancelButton: 'btn btn-secondary',
    container: 'container-class modal-conta'
  },
  buttonsStyling: false
})

export default {
  name: 'ListaUsuarios',
  components: {
    InfiniteLoading,
    ModalAjustaTempoAcesso,
    ModalCadastroUsuario,
    ModalExclusaoUsuarios,
    ModalImportacaoUsuarios,
    ModalTrocaEmail,
    ModalMigracaoProgressoUsuarios
  },
  data () {
    return {
      buscaUsuario: '',
      idUsuarioTrocaEmail: null,
      faculdades: [],
      filtroBusca: '',
      infiniteId: new Date(),
      pagina: 1,
      planos: [],
      quantidade: 0,
      scrolled: false,
      selectAll: false,
      shiftPressed: false,
      ultimoSelecionado: '',
      usuarios: [],
      usuarioEdicao: null,
      usuarioTempoAcesso: null,
      usuariosSelecionados: []
    }
  },

  created () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('keyup', this.handleKeyUp)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('keyup', this.handleKeyUp)
  },

  watch: {
    selectAll: function (value) {
      if (value) {
        this.usuariosSelecionados = this.usuarios
      } else {
        this.usuariosSelecionados = []
      }
    }
  },

  async mounted () {
    this.listarUsuarios()
    this.faculdades = await FaculdadeAPI.listar()
    this.planos = await PlanoAPI.listarPlanosEmpresa()
  },

  methods: {
    handleScroll: function () {
      this.scrolled = window.scrollY > 100
    },

    handleKeyDown: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = true
      }
    },

    handleKeyUp: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = false
      }
    },

    scrollToTop: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },

    selecionarUsuario: function (event) {
      if (event.key === 'Enter') {
        this.listarUsuarios()
      }
    },

    infiniteHandler: function ($state) {
      UsuarioAPI.listar(this.pagina, this.filtroBusca).then(data => {
        this.quantidade = data.total

        if (this.pagina <= data.last_page) {
          this.usuarios.push(...data.data.map(item => {
            return Object.assign(item, {
              nome: item.name,
              dataCriacao: item.created_at ? DateUtils.formatDate(item.created_at, 'DD/MM/YYYY') : '',
              perfil: TipoPerfilUtil.obterPorId(item.perfil_id).nome,
              playerAlternativo: !!item.player_alternativo
            })
          }))
          $state.loaded()

          if (this.pagina === data.last_page) {
            $state.complete()
          } else {
            this.pagina += 1
          }
        } else {
          $state.complete()
        }
      }).catch(error => ResponseUtils.handleError(error))
    },

    listarUsuarios: function () {
      this.filtroBusca = this.buscaUsuario

      this.infiniteId = new Date()
      this.pagina = 1
      this.quantidade = 0
      this.usuarios = []
      this.usuariosSelecionados = []
    },

    limparFiltro: function () {
      this.buscaUsuario = ''
      this.filtroBusca = ''

      this.listarUsuarios()
    },

    obterIdUsuarioTrocaEmail: async function (idUsuario) {
      this.idUsuarioTrocaEmail = idUsuario
    },

    alteraSelecionado: function (usuario) {
      if (this.shiftPressed && this.ultimoSelecionado) {
        let maiorQueUltimo = (usuario.id > this.ultimoSelecionado.id)
        let novosSelecionados
        novosSelecionados = this.usuarios.filter(item => {
          if (maiorQueUltimo) {
            return (item.id <= usuario.id) && (item.id >= this.ultimoSelecionado.id)
          } else {
            return (item.id <= this.ultimoSelecionado.id) && (item.id >= usuario.id)
          }
        })
        novosSelecionados.map(usuario => {
          !this.usuariosSelecionados.includes(usuario) && this.usuariosSelecionados.push(usuario)
        })
      }
      this.ultimoSelecionado = usuario
    },

    importacaoFinalizada: function (statusImportacao) {
      localStorage.setItem('resultado-importacao', JSON.stringify(statusImportacao.resultados))

      this.listarUsuarios()

      customSwal.fire({
        icon: statusImportacao.quantidadeErros ? 'warning' : 'success',
        html: 'Importação de usuários concluída.<br>' +
          `Total de registros: <strong>${statusImportacao.total}</strong><br>` +
          `Cadastrados com sucesso: <strong>${statusImportacao.quantidadeSucessos}</strong> ` +
          `- Erros: <strong>${statusImportacao.quantidadeErros}</strong><br>` +
          '<a href="/conta/importacao/resultado" target="_blank">Clique aqui para visualizar o relatorio</a>',
        showCloseButton: true,
        confirmButtonText: 'Ok'
      })
    },

    confirmGerarAcesso: function (usuario) {
      customSwal.fire({
        icon: 'question',
        text: 'Deseja gerar uma link de acesso para este usuário?',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          UsuarioAPI.gerarAcesso(usuario.id).then(data => {
            loader.hide()

            Swal.fire({
              title: data.message,
              html: '<a target="_blank" href="' + data.link + '">' + data.link + '</a>',
              icon: 'success'
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      })
    },

    resetarProgresso: function (usuario) {
      customSwal.fire({
        icon: 'question',
        text: 'Deseja resetar o progresso para este usuário?',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          UsuarioAPI.resetarProgresso(usuario).then(data => {
            loader.hide()

            Swal.fire({
              title: 'Progresso do usuário resetado com sucesso.',
              icon: 'success'
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      })
    },

    confirmRemoverUsuario: function (usuario) {
      customSwal.fire({
        title: '<i class="fas fa-trash-alt my-4" aria-hidden="true"></i>',
        html: 'Tem certeza que deseja excluir esse usuário?',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.value) {
          const loader = this.$loading.show()

          UsuarioAPI.remover(usuario.id).then(data => {
            loader.hide()

            if (data.status === true) {
              this.usuarios = this.usuarios.filter(item => item.id !== usuario.id)
              Swal.fire(
                'Removido!',
                `O usuário <strong>${usuario.nome}</strong> foi removido`,
                'success'
              )
            }
          })
        }
      })
    },

    confirmRemoverUsuarioPorLote: function () {
      customSwal.fire({
        title: '<i class="fas fa-trash-alt my-4" aria-hidden="true"></i>',
        html: `Tem certeza que deseja excluir esses ${this.usuariosSelecionados.length} usuários?`,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.value) {
          const loader = this.$loading.show()

          let usersIds = []

          this.usuariosSelecionados.map(usuario => {
            usersIds.push(usuario.id)
          })

          UsuarioAPI.removerPorLote(usersIds).then(data => {
            loader.hide()

            if (data.status === true) {
              Swal.fire(
                'Removido!',
                'Os usuários foram removidos.',
                'success'
              ).then(() => {
                this.listarUsuarios()
              })
            }
          })
        }
      })
    },

    modalCadastrarUsuario: function () {
      this.usuarioEdicao = null

      this.$nextTick(() => {
        this.$refs.modalCadastroUsuario.show()
      })
    },

    modalMigrarProgressoUsuarios: function () {
      this.$nextTick(() => {
        this.$refs.modalMigrarProgressoUsuarios.show()
      })
    },

    modalImportarListaUsuarios: function () {
      this.$nextTick(() => {
        this.$refs.modalImportarListaUsuarios.show()
      })
    },

    modalExcluirListaUsuarios: function () {
      this.$nextTick(() => {
        this.$refs.modalExcluirListaUsuarios.show()
      })
    },

    modalEditarUsuario: function (usuario) {
      this.usuarioEdicao = usuario

      this.$nextTick(() => {
        this.$refs.modalCadastroUsuario.show()
      })
    },

    modalAjustaTempoAcesso: function (usuario) {
      this.usuarioTempoAcesso = usuario

      this.$nextTick(() => {
        this.$refs.modalAjustaTempoAcesso.show()
      })
    },
    definirSenha: function (usuario) {
      customSwal.fire({
        icon: 'question',
        text: 'Deseja gerar uma senha padrão de acesso para este usuário?',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          UsuarioAPI.definirSenha(usuario.id).then(data => {
            loader.hide()

            Swal.fire({
              title: data.message,
              html: '<p>Login: ' + usuario.email + ' <br> Senha: ' + data.retorno + '</>',
              icon: 'success'
            })
            this.listarUsuarios()
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      })
    },

    validarEmail: function (usuarioId) {
      customSwal.fire({
        icon: 'question',
        text: 'Deseja validar o email desse usuário?',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          UsuarioAPI.validarEmail(usuarioId).then(data => {
            loader.hide()

            Swal.fire({
              title: '',
              html: 'Email validado com sucesso.',
              icon: 'success'
            })
            this.listarUsuarios()
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      })
    },

    alternarPlayerAlternativo: async function (checked, usuario) {
      const loader = this.$loading.show()
      usuario.player_alternativo = checked ? 1 : 0
      await UsuarioAPI.alternarPlayerAlternativo(usuario)
      loader.hide()
    }
  }
}
</script>

<style>
  h2 {
    border-left: 0px!important;
  }

  strong {
    font-weight: bold!important;
  }
</style>
